module.exports = __webpack_public_path__ + "img/icon_seo.65dd0e62.png";